import styled from 'styled-components';

import { SectionTitleStyled } from '@components/Slider/styled';
import { Title } from '@components/ui/filters/MultiSelectionFilter/MultiSelectionFilterStyle';

export const SectionWrapperStyled = styled.div`
  width: 100%;
  padding: 20px 20px 20px 20px;
  background-color: ${({ theme }) => theme.palette.white};
  margin-bottom: 20px;
  border-radius: 4px;

  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    padding: 12px;
  }

  ${SectionTitleStyled}, ${Title} {
    color: ${({ theme }) => theme.palette.grey1100};
  }
`;

export const MobileFilterButtonWrapper = styled.div`
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    width: calc(100% + 24px);
    margin-left: -12px;
    border-bottom: 1px solid ${({ theme }) => theme.palette.grey300};
    padding-bottom: 12px;
  }
`;
